import { render, staticRenderFns } from "./sweetDetail.vue?vue&type=template&id=1ea2799c&scoped=true"
import script from "./sweetDetail.vue?vue&type=script&lang=js"
export * from "./sweetDetail.vue?vue&type=script&lang=js"
import style0 from "./sweetDetail.vue?vue&type=style&index=0&id=1ea2799c&prod&scoped=true&lang=less"
import style1 from "./sweetDetail.vue?vue&type=style&index=1&id=1ea2799c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea2799c",
  null
  
)

export default component.exports